<template>
  <div>
    <CustomerAddNew
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <CustomerInfoAddNew :isSidebarInfoActive="addNewInfoDataSidebar" :data="infoData" />
    <EmployeeAddNew
      :isPromptActiveEmployee="isPromptActiveEmployeeLocal"
      :data="employeeData"
    />
    <CustomerActAddNew
      :isSidebarActive="addNewActSidebar"
      @closeSidebar="toggleActSidebar"
      :data="sidebarAct"
    />

    <vs-card>
      <b-row class="justify-content-md-start" v-if="!isMobile()">
        <b-col cols="3">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="searchedVal"
              id="smallInput"
              :placeholder="$t('Search')"
              @keyup.enter="filterCustomerList"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <b-button
            class="bg-primary"
            style="border-color: white"
            size="sm"
            v-on:click="filterCustomerList()"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <success-btn
            :bgcolor="'bg-success'"
            :title="'AddNew'"
            :icon="'mingcute:add-line'"
            :size="'sm'"
        /></b-col>
				<b-col>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium"
            >
              <span class="mr-2 leading-none">{{ $t("TotalActions") }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="
                  wholeStockActions = true;
                  deleteCustomer();
                "
              >
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("Delete") }}</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-start" v-else>
        <b-col cols="6">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="searchedVal"
              id="smallInput"
              :placeholder="$t('Search')"
              @keyup.enter="filterCustomerList"
              size="sm"
            />
          </b-form-group>
        </b-col>

        <b-col cols="2" style="padding-left: 0px !important">
          <b-button
            class="bg-primary"
            style="border-color: white"
            size="sm"
            v-on:click="filterCustomerList()"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>
        <b-col cols="4" style="padding-left: 0px !important">
          <success-btn
            :bgcolor="'bg-success'"
            :title="'AddNew'"
            :icon="'mingcute:add-line'"
            :size="'sm'"
        /></b-col>
				<b-col>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium"
            >
              <span class="mr-2 leading-none">{{ $t("TotalActions") }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="
                  wholeStockActions = true;
                  deleteCustomer();
                "
              >
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("Delete") }}</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </b-col>
      </b-row>
      <b-row>
        

        <ag-grid-vue
          ref="agGridTable"
          class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
          :columnDefs="customerColumns"
          :defaultColDef="defaultColDef"
          :rowData="companyList"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          @grid-ready="onGridReady"
          :suppressCopyRowsToClipboard="true"
          :localeText="localeText"
          :suppressRowClickSelection="true"
        >
        </ag-grid-vue>
      </b-row>
    </vs-card>

    <DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
  </div>
</template>
<script>
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import { Icon } from "@iconify/vue2";
import SuccessBtn from "../../components/vx-button/SuccessBtn.vue";
import EmployeeAddNew from "./EmployeeAddNew.vue";
import CustomerAddNew from "./CustomerAddNew.vue";
import CustomerInfoAddNew from "./CustomerInfoAddNew.vue";
import customerUpdateBtnCellRenderer from "../CellRenderers/customerUpdateBtnCellRenderer.vue";
import imgShowCellRenderer from "./CellRenderers/imgShowCellRenderer.vue";
import imgShowCellRendererSignLogo from "./CellRenderers/imgShowCellRendererSignLogo.vue";
import { isMobile } from "mobile-device-detect";
import i18nData from "../../i18n/i18nData";
import statusShowCellRenderer from "../CellRenderers/statusShowCellRenderer.vue";
import CustomerActAddNew from "./CustomerActAddNew.vue";

export default {
  components: {
    CustomerActAddNew,
    wholeStockActions: false,
    EmployeeAddNew,
    statusShowCellRenderer,
    imgShowCellRendererSignLogo,
    imgShowCellRenderer,
    AgGridVue,
    Icon,
    SuccessBtn,
    CustomerAddNew,
    customerUpdateBtnCellRenderer,
    DeleteWarning,
    CustomerInfoAddNew,
  },
  data() {
    return {
      sidebarAct: {},
      addNewActSidebar: false,
      companyList: [],
      gridApi: null,
      employeeData: [],
      isPromptActiveEmployeeLocal: false,
      isMobile: function () {
        return isMobile;
      },
      infoData: [],
      deleteWarningPromptValid: false,
      addNewDataSidebar: false,
      addNewInfoDataSidebar: false,
      sidebarData: {},
      searchedVal: "",
      companyListFiltered: this.company,
      customerColumns: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      deleteData: [{}],
    };
  },

  methods: {
    deleteSubmitAll() {
      var selectedRows = this.gridApi.getSelectedRows();
      selectedRows.forEach((val, index) => {
        this.deleteSubmit(val);
      });
    },
    addCustomerAct(param) {
      this.sidebarAct = param;
      this.toggleActSidebar(true);
    },
    toggleActSidebar(val = false) {
      this.addNewActSidebar = val;
    },

    closeEmployeeData() {
      this.isPromptActiveEmployeeLocal = false;
    },
    addEmployeeData(data) {
      this.employeeData = data;
      this.isPromptActiveEmployeeLocal = true;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    filterCustomerList() {
      this.companyList = this.companyListFiltered;
      this.companyList = this.company.filter((post) => {
        return (
          post.CompanyName.toUpperCase().includes(this.searchedVal.toUpperCase()) ||
          post.CompanyNo.toUpperCase().includes(this.searchedVal.toUpperCase())
        );
      });
    },
    getCustomerList() {
      console.log("inn");
      const vs = this.$vs;
      this.customerColumns = [];
      this.companyListFiltered = this.company;
      this.companyList = this.company;
      try {
        if (this.company.length > 0) {
          let columnList = Object.keys(this.company[0]);
          this.customerColumns.push({
            headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            width: 250,
            pinned: "left",
            cellRendererFramework: "customerUpdateBtnCellRenderer",
            cellRendererParams: {
              addMethods: "addInfoData",
              addMethodsEmployee: "addEmployeeData",
            },
          });
          columnList.forEach((val, index) => {
            if (val == "CompanyLogo") {
              if (this.isMobile())
                this.customerColumns.push({
                  width: 80,
                  headerName: this.$t(val),
                  cellRendererFramework: "imgShowCellRenderer",
                  field: val,
                  filter: "agSetColumnFilter",
                });
              else
                this.customerColumns.push({
                  width: 80,
                  headerName: this.$t(val),
                  cellRendererFramework: "imgShowCellRenderer",
                  pinned: "left",
                  field: val,
                  filter: "agSetColumnFilter",
                });
            } else if (val == "Status")
              this.customerColumns.push({
                width: 80,
                headerName: this.$t(val),
                cellRendererFramework: "statusShowCellRenderer",
                field: val,
                filter: "agSetColumnFilter",
              });
            else if (val == "CompanySignLogo") {
              if (this.isMobile())
                this.customerColumns.push({
                  width: 80,
                  headerName: this.$t(val),
                  cellRendererFramework: "imgShowCellRendererSignLogo",
                  field: val,
                  filter: "agSetColumnFilter",
                });
              else
                this.customerColumns.push({
                  width: 80,
                  headerName: this.$t(val),
                  cellRendererFramework: "imgShowCellRendererSignLogo",
                  pinned: "left",
                  field: val,
                  filter: "agSetColumnFilter",
                });
            } else if (val == "CompanyName" || val == "CompanyNo") {
              if (this.isMobile())
                this.customerColumns.push({
                  headerName: this.$t(val),
                  field: val,
                  filter: "agSetColumnFilter",
                });
              else
                this.customerColumns.push({
                  headerName: this.$t(val),
                  pinned: "left",
                  field: val,
                  filter: "agSetColumnFilter",
                });
            } else if (val != "CompanyId" && val.toString().includes("Date") == false)
              this.customerColumns.push({
                headerName: this.$t(val),
                field: val,
                filter: "agSetColumnFilter",
              });
            else if (val.toString().includes("Date") == true) {
              this.customerColumns.push({
                headerName: this.$t(val),
                field: val,
                filter: "agSetColumnFilter",
                valueFormatter: (params) => this.parseDate(params.data[val]),
              });
            }
          });
          if (this.searchedVal != "") this.filterCustomerList();
        }
      } catch (error) {
        console.log(error);
      }
    },
    updateCustomer(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    deleteCustomer(data) {
      this.deleteWarningPromptValid = true;
    },
    addInfoData(data) {
      this.infoData = data;
      this.addNewInfoDataSidebar = true;
    },
    closeInfoData() {
      this.addNewInfoDataSidebar = false;
    },
    closeDeleteWarning() {
      this.deleteWarningPromptValid = false;
    },
    deleteSubmit(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("customer/deleteCustomer", data.CompanyId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getCustomerList();
              this.deleteWarningPromptValid = false;
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
  },
  created() {
    this.getCustomerList();
  },
  watch: {
    company(val) {
      this.getCustomerList();

      console.log(val);
      return val;
    },
  },
  computed: {
    company: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("addCustomerAct", (param) => {
      this.addCustomerAct(param);
    });
    this.$root.$on("addNewData", () => {
      this.addNewData();
    });
    this.$root.$on("getCustomerList", () => {
      this.getCustomerList();
    });
    this.$root.$on("editData", (data) => {
      this.updateCustomer(data);
    });
    this.$root.$on("deleteData", (data) => {
      this.deleteData = data;
      this.deleteCustomer(data);
    });
    this.$root.$on("deleteSubmit", (data) => {
      if (this.wholeStockActions == true) this.deleteSubmitAll();
      else this.deleteSubmit(data);
    });
    this.$root.$on("addInfoData", (data) => {
      this.addInfoData(data);
    });
    this.$root.$on("addEmployeeData", (data) => {
      this.addEmployeeData(data);
    });
    this.$root.$on("closeInfoData", () => {
      this.closeInfoData();
    });
    this.$root.$on("closeDeleteWarning", () => {
      this.closeDeleteWarning();
    });
    this.$root.$on("closeEmployeeData", () => {
      this.closeEmployeeData();
    });
  },
  beforeDestroy() {
    this.$root.$off("addNewData");
    this.$root.$off("addCustomerAct");
    this.$root.$off("getCustomerList");
    this.$root.$off("editData");
    this.$root.$off("deleteData");
    this.$root.$off("deleteSubmit");
    this.$root.$off("addInfoData");
    this.$root.$off("closeInfoData");
    this.$root.$off("closeDeleteWarning");
    this.$root.$off("addEmployeeData");
    this.$root.$off("closeEmployeeData");
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
